import api from '@/api/axiosApi'
import type {
  NotificationRead,
  NotificationListResponse,
  MarkAllReadResponse,
} from '@/types/notification'

export interface FetchNotificationsParams {
  offset?: number
  limit?: number
  category?: string
  is_read?: boolean
}

export async function fetchNotifications(
  params: FetchNotificationsParams = {}
): Promise<NotificationListResponse> {
  const { data } = await api.get<NotificationListResponse>('/notifications', {
    params,
  })
  return data
}

export async function fetchNotification(id: string): Promise<NotificationRead> {
  const { data } = await api.get<NotificationRead>(`/notifications/${id}`)
  return data
}

export async function markNotificationRead(
  id: string,
  is_read: boolean
): Promise<NotificationRead> {
  const { data } = await api.patch<NotificationRead>(`/notifications/${id}`, {
    is_read,
  })
  return data
}

export async function markAllNotificationsRead(): Promise<MarkAllReadResponse> {
  const { data } = await api.post<MarkAllReadResponse>(
    '/notifications/read-all'
  )
  return data
}
